export const ZOOM_MIN = 50;
export const ZOOM_MAX = 250;
export const ZOOM_STEP = 25;
export const ZOOM_DEFAULT = 100;

export const PREVIEW_ERROR_TITLE = "We couldn't load this file";
export const PREVIEW_ERROR_BODY = "The preview didn't load. Check your connection and try again.";
